import { styled } from '@aibi-ui/core';
import { Tooltip } from 'antd';
import ImgSenderButton from '../../../assets/images/sender-button.png';
import StopLoading from './StopLoading';

const SendButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 28px;
  height: 28px;
  cursor: pointer;
  button {
    width: 28px;
    height: 28px;
    background: none;
    color: inherit;
    border: none;
    padding: 0;
    margin: 0;
    font: inherit;
    cursor: pointer;
    transition: all 0.2s ease;
    border-radius: 50%;
  }
  .send {
    opacity: 0.9;
    border-radius: 50%;
    &.disabled {
      opacity: 0.7;
      &:hover {
        opacity: 0.7;
      }
      &:focus {
        opacity: 0.7;
      }
    }
    &:hover {
      opacity: 0.77;
    }
    &:focus {
      opacity: 1;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
  .loading {
    color: #1677ff;
    &:hover {
      background: #e6f4ff;
    }
  }
`;

const SendButton = ({
  handleSend,
  onStop,
  canStop,
  disabled,
}: {
  handleSend: () => void;
  onStop: () => void;
  canStop: boolean;
  disabled?: boolean;
}) => {
  return (
    <SendButtonContainer>
      {!canStop ? (
        <Tooltip title="发送">
          <button
            className={`'send', ${disabled ? 'disabled' : ''}`}
            onClick={handleSend}
            disabled={disabled}
          >
            <img src={ImgSenderButton} alt="发送" />
          </button>
        </Tooltip>
      ) : (
        <Tooltip title="停止生成">
          <button className="loading" onClick={onStop}>
            <StopLoading />
          </button>
        </Tooltip>
      )}
    </SendButtonContainer>
  );
};

export default SendButton;
